import {
  mdiDotsSquare,
  mdiViewDashboardOutline,
  mdiAccountClockOutline,
  mdiCalendarClock,
  mdiScriptTextOutline,
  mdiDatabaseOutline,
  mdiCogs,
  mdiQrcode,
} from '@mdi/js'
import useCurrentData from '@/views/composable/useCurrentData'

const buildRoute = (name, clubSlug) => ({
  name,
  params: {
    club_slug: clubSlug,
  },
})

// customユーザー用サイドバー
// 各項目は custom:* サブジェクトで表示制御される
// PermissionGroupで付与された権限に応じて動的に表示/非表示が決まる
export default function sidebarContent() {
  const { currentClub: currentClubRef } = useCurrentData()
  const currentClub = currentClubRef.value || {}
  const clubSlug = currentClub?.slug

  return [
    {
      title: 'ホール',
      icon: mdiDotsSquare,
      to: buildRoute('waiter-halls', clubSlug),
      action: 'read',
      resource: 'custom:hall',
    },
    {
      title: 'フロアマップ',
      icon: mdiViewDashboardOutline,
      to: buildRoute('waiter-floor', clubSlug),
      action: 'read',
      resource: 'custom:hall',
    },
    {
      title: 'オーダー',
      icon: mdiScriptTextOutline,
      to: buildRoute('waiter-orders', clubSlug),
      action: 'read',
      resource: 'custom:order',
    },
    {
      title: '勤怠/待機',
      icon: mdiAccountClockOutline,
      to: buildRoute('waiter-timecards', clubSlug),
      action: 'read',
      resource: 'custom:timecard',
    },
    {
      title: '営業予定',
      icon: mdiCalendarClock,
      to: buildRoute('waiter-business-schedule', clubSlug),
      action: 'read',
      resource: 'custom:settings_work_schedule',
    },
    {
      title: 'データ',
      icon: mdiDatabaseOutline,
      to: buildRoute('waiter-data', clubSlug),
      action: 'read',
      resource: 'custom:data',
    },
    {
      title: '打刻QRコード',
      icon: mdiQrcode,
      to: buildRoute('admin-cast-app-punch-qr', clubSlug),
      action: 'read',
      resource: 'custom:punch_qr',
    },
    {
      title: '設定',
      icon: mdiCogs,
      children: [
        {
          title: 'ホール',
          to: buildRoute('waiter-settings-halls', clubSlug),
          action: 'read',
          resource: 'custom:settings_hall',
        },
        {
          title: 'フロアレイアウト',
          to: buildRoute('waiter-settings-floor', clubSlug),
          action: 'read',
          resource: 'custom:settings_hall',
        },
        {
          title: 'プリンタ設定',
          to: buildRoute('waiter-settings-printers', clubSlug),
          action: 'read',
          resource: 'custom:settings_printer',
        },
        {
          title: 'メニュー',
          to: buildRoute('waiter-settings-vendibles', clubSlug),
          action: 'read',
          resource: 'custom:settings_vendible',
        },
        {
          title: '商品タグ',
          to: buildRoute('waiter-settings-vendible-tags', clubSlug),
          action: 'read',
          resource: 'custom:settings_vendible_tag',
        },
        {
          title: `${currentClub?.referralAlias || 'リファラル'}`,
          to: buildRoute('waiter-settings-referrals', clubSlug),
          action: 'read',
          resource: 'custom:settings_referral',
        },
        {
          title: '顧客タグ',
          to: buildRoute('waiter-settings-customer-tags', clubSlug),
          action: 'read',
          resource: 'custom:settings_customer_tag',
        },
        {
          title: '顧客管理',
          to: buildRoute('waiter-settings-customer-management', clubSlug),
          action: 'read',
          resource: 'custom:settings_customer',
        },
        {
          title: '売上計上トリガー',
          to: buildRoute('waiter-settings-vending-contribution-triggers', clubSlug),
          action: 'read',
          resource: 'custom:settings_trigger',
        },
        {
          title: 'ユーザー',
          to: buildRoute('waiter-settings-users', clubSlug),
          action: 'read',
          resource: 'custom:settings_user',
        },
        {
          title: `${currentClub?.name || '店舗'}`,
          to: buildRoute('waiter-settings-club', clubSlug),
          action: 'read',
          resource: 'custom:settings_club',
        },
      ],
    },
  ]
}
